/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Adunit/theme';

export const AdunitTheme = theme;
